import formAPIpostprandialbloodglucose from "./postsugar";


var formattedOutput = null;

const formAPIModelpostprandialbloodglucose = (data, type) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPIpostprandialbloodglucose(item, type));


  return formattedOutput
};

export default formAPIModelpostprandialbloodglucose